module.exports = __webpack_public_path__ + "static/media/phone_icon.f3ac43c9.svg";